import { Injectable } from '@angular/core'

import { toast } from 'ngx-sonner'

@Injectable({ providedIn: 'root' })
export class ToastService {
  success(message: string, description?: string) {
    toast.success(message, { description })
  }

  error(message: string, description?: string) {
    toast.error(message, { description })
  }

  info(message: string, description?: string) {
    toast.info(message, { description })
  }

  custom(message: string, options?: Parameters<typeof toast>[1]) {
    toast(message, options)
  }
}
